
import * as ipxRuntime$1Mcya1lyif from '/app/node_modules/.pnpm/@nuxt+image@1.9.0/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 376,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1366,
    "4xl": 1920,
    "3xl": 1536,
    "2xs": 360
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "p003-03.staging2.performing.digital",
    "p002-03.staging2.performing.digital",
    "shop.ducatimilano.com",
    "shop.pogliani.com",
    "shop-cms.pogliani.com",
    "shop-cms.ducatimilano.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$1Mcya1lyif, defaults: {} }
}
        